import React from "react";
import { useTranslation } from "react-i18next";
import { Box, useTheme } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";

export interface VerifiedBadgeProps {
  verified?: boolean | null;
  /** "onDark" matches dark surfaces such as the quote action card. */
  tone?: "default" | "onDark";
}

/** Marks a vendor an admin has checked. Renders nothing for everyone else. */
const VerifiedBadge: React.FC<VerifiedBadgeProps> = ({
  verified,
  tone = "default",
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  if (!verified) {
    return null;
  }

  return (
    <Box
      component="span"
      title={t("ui.verified_title")}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        fontSize: "0.85rem",
        fontWeight: 600,
        color:
          tone === "onDark"
            ? theme.palette.common.white
            : theme.palette.success.main,
      }}
    >
      <VerifiedIcon
        sx={{
          fontSize: 18,
          color:
            tone === "onDark"
              ? theme.palette.success.light
              : theme.palette.success.main,
        }}
      />
      {t("ui.verified")}
    </Box>
  );
};

export default VerifiedBadge;
